<template>


  <div class="clearfix">
    <vs-popup class="holamundo" style="text-align: justify !important; " title="Términos y Condiciones de la Plataforma de Lealtad VIVOTEK" :active.sync="popupActivo">
      <p>
        <b>NATURALEZA JURÍDICA</b><br><br>
        El presente documento contiene los Términos y Condiciones que establecen una
        relación contractual entre usted (usuario o consumidor) y la Plataforma de Lealtad
        VIVOTEK (operador), regulando su acceso y uso de nuestros servicios.
        Al utilizar los servicios de la Plataforma de Lealtad VIVOTEK, usted acepta
        automáticamente los Términos y Condiciones a continuación descritos, por lo que
        le sugerimos leer detenidamente el presente documento. Si usted no está de
        acuerdo con todos los Términos y Condiciones aquí establecidos, no podrá utilizar
        los servicios de la Plataforma de Lealtad VIVOTEK.<br><br>
        <b>ASPECTOS ESPECÍFICOS</b><br><br>
        CUENTA DE USUARIO<br>
        Para poder hacer uso de nuestros servicios, en caso de pertenecer a la categoría
        Silver. Usted deberá adquirir cualquier dispositivo VIVOTEK, cursar de manera
        satisfactoria cualquier curso comercial dentro de la plataforma de aprendizaje
        VIVOTEK. Para el caso de las categorías Platinum y Gold, se debe esperar una
        invitación por parte de VIVOTEK.
        Es de usted la responsabilidad de mantener la confidencialidad de los datos de su
        cuenta, por lo que no deberá compartir su nombre de usuario ni su contraseña con
        terceras personas y deberá proteger la seguridad de la misma. Usted asume la
        responsabilidad de cualquier actividad realizada desde su cuenta o utilizando su
        contraseña.
        La Plataforma de Lealtad VIVOTEK se reserva el derecho de dar de baja, eliminar
        o editar contenido de cuentas, así como de cancelar servicios en caso de incumplir
        los presentes Términos y Condiciones, al cometer un delito o dañar la reputación
        de la Plataforma de Lealtad VIVOTEK o la experiencia del usuario o consumidor.
        Para tener acceso total a nuestros servicios, es necesario que nos comparta datos
        específicos sobre su información personal (nombre completo, domicilio, correo
        electrónico, fotografía y RFC). Los datos proporcionados deberán ser precisos y
        verdaderos, mismos que necesitará actualizar cuando sea el caso.
        La Plataforma de Lealtad VIVOTEK se reserva el derecho de solicitar un
        comprobante para corroborar los datos personales, así como de suspender
        temporal o definitivamente las cuentas de los usuarios cuya información no haya
        podido ser corroborada.<br><br>
        CAPACIDAD LEGAL<br>
        De acuerdo con la legislación mexicana vigente y en virtud de la validez de la
        manifestación de voluntad a través de medios electrónicos establecida en el
        Código Civil Federal, los usuarios y consumidores de la Plataforma de Lealtad
        VIVOTEK manifiestan expresamente, al momento de ingresar y hacer uso de la
        misma, tener capacidad suficiente para celebrar este contrato de prestación de
        servicios.<br><br>
        MANEJO DE INFORMACIÓN<br>
        La información del usuario o consumidor recabada por la Plataforma de Lealtad
        VIVOTEK (la cual es proporcionada de manera voluntaria para la creación de su
        cuenta) también es administrada y almacenada por VIVOTEK con fines
        comerciales, publicitarios y de mercadeo, formando parte de un proceso interno
        que nos permite mejorar la calidad de nuestros productos.<br><br>
        COMUNICACIONES<br>
        Al hacer uso de nuestros servicios o al establecer comunicación con nosotros a
        través de cualquier dispositivo, usted acepta recibir comunicaciones electrónicas
        relacionadas con la Plataforma de Lealtad VIVOTEK vía correo electrónico, tales
        como ofertas sobre nuestros dispositivos, noticias relevantes de la empresa,
        lanzamientos de productos, o para hacer cumplir los presentes Términos y
        Condiciones, nuestras políticas y la ley aplicable.
        De igual manera, nos autoriza conservar copias de cualquiera de las
        comunicaciones mencionadas para futuras referencias, las cuales, junto con todos
        los Términos y Condiciones y demás documentos que le enviemos vía correo
        electrónico, tendrán el mismo valor jurídico que si estuvieran establecidas por
        escrito.<br><br>
        DERECHOS DE AUTOR<br>
        VIVOTEK se reserva, de manera enunciativa mas no limitativa, todos los derechos
        de propiedad intelectual e industrial asociados con los servicios de la Plataforma
        de Lealtad VIVOTEK y el contenido alojado en su plataforma, incluyendo textos,
        materiales gráficos, logotipos, íconos, imágenes, fotografías, descargas digitales,
        programas, bases de datos, redes, códigos, desarrollo, software, arquitectura,
        hardware, información, tecnología, fases de integración, funcionalidades,
        dominios, archivos que permiten al usuario acceder y crear su cuenta,
        herramientas de venta, marcas, patentes, diseños y nombres comerciales, entre
        otros; por lo que todos los elementos visibles y no visibles que forman parte de la
        Plataforma de Lealtad VIVOTEK están protegidos por los tratados internacionales
        y la legislación nacional en materia de propiedad intelectual y de derechos de
        autor, aplicables en el Estado mexicano.<br><br>
        FUNCIONAMIENTO DE LA PLATAFORMA<br>
        La Plataforma de Lealtad VIVOTEK está disponible las 24 horas del día para su
        acceso y consulta; sin embargo, la disponibilidad de adquisición de los productos
        ofertados en ella dependerá de la disponibilidad de los mayoristas en relación con
        dichos productos.<br><br>
        DESCRIPCIÓN DEL SERVICIO<br>
        La Plataforma de Lealtad VIVOTEK exhibe a través de su plataforma un catálogo
        de productos relacionados con la industria de la seguridad y de las tecnologías de
        la información. Dichos productos son exhibidos como referencia para que los
        usuarios o consumidores realicen un pedido de compra.<br><br>
        DESCRIPCIÓN DEL PRODUCTO<br>
        La información contenida en nuestra plataforma sobre los productos ofertados
        tiene fines meramente informativos, por lo que la Plataforma de Lealtad VIVOTEK
        no garantiza que las descripciones de los productos estén libres de errores.<br><br>
        DEBERES DEL OPERADOR<br>
        La Plataforma de Lealtad VIVOTEK está obligada a indicar las características
        generales de los productos; comunicar al usuario o consumidor una constancia
        sobre su pedido; y utilizar la información personal del usuario o consumidor única
        y exclusivamente para los fines establecidos en los presentes Términos y
        Condiciones. La Plataforma de Lealtad VIVOTEK también podrá exhibir en su plataforma
        información de carácter comercial y publicitario, propio o de terceros, de acuerdo
        con las buenas costumbres comerciales. En estos casos, la Plataforma de Lealtad
        VIVOTEK no se hace responsable de los servicios o productos comercializados
        por terceros, por lo que es responsabilidad de usted verificar y conocer los
        términos de los servicios ofrecidos por terceros.<br><br>
        OBLIGACIONES DEL CONSUMIDOR<br>
        Usted está obligado a abstenerse de transferir a terceros su nombre de usuario y
        contraseña; abstenerse de acceder y usar nuestra plataforma para realizar actos
        contrarios a la moral, al orden público, a las buenas costumbres o actos ilícitos en
        contra de la Plataforma de Lealtad VIVOTEK, de su personal o de terceros;
        informar inmediatamente a la Plataforma de Lealtad VIVOTEK en caso de olvido o
        usurpación de sus datos de validación (nombre y contraseña); y abstenerse de
        suplantar la identidad de otros usuarios o consumidores.<br><br>
        FORMAS DE PAGO<br>
        El usuario o consumidor podrá intercambiar los productos ofertados en la
        Plataforma de Lealtad VIVOTEK por VIVOCOINS, unidad de cambio exclusiva de
        VIVOTEK con la que es posible canjear aquellos productos que cuentan con Mac
        Address (número único de identificación que podrá validar la garantía del
        producto).Usted deberá registrar sus proyectos y los productos adquiridos a través de su
        Distribuidor Autorizado por VIVOTEK en la Plataforma de Lealtad VIVOTEK (sin
        importar que hayan sido adquiridos desde el 2019) para hacerse acreedor de los
        puntos que se utilizan en dicho sistema de canje.<br><br>
        VIVOCOINS<br>
        El Programa de Lealtad VIVOTEK asigna una cantidad determinada de puntos
        para nuestras categorías Platinum y Gold, (para conocer la cantidad de puntos
        asignados, le invitamos a revisar las hojas de beneficios de ambos programas) a
        los cuales les llamamos VIVOCOINS.
        Estos VIVOCOINS sirven para canjear productos en la tienda de la plataforma.
        Además, que cuando los integradores registren los dispositivos comprados con
        nuestros distribuidores en la sección de proyectos, cada dispositivo otorga una
        determinada cantidad de VIVOCOINS.<br><br>
        DISPONIBILIDAD<br>
        La Plataforma de Lealtad VIVOTEK no garantiza la existencia de los artículos
        ofertados en la plataforma, ya que toda la información sobre la disponibilidad,
        entrega o envío de productos está basada en estimaciones aproximadas.
        Si ordena algún producto que, por cualquier razón deje de estar disponible en la
        plataforma, no se le quitarán los VIVOCOINS correspondientes o, en su defecto, le
        serán regresados en su totalidad.
        Los puntos de los que usted disponga en la Plataforma de Lealtad VIVOTEK
        tienen una vigencia de 12 meses, mismos que desaparecerán automáticamente
        de no ser aprovechados en dicho periodo.<br><br>
        RIESGO DE PÉRDIDA<br>
        El riesgo de pérdida de nuestros productos le será transferida a usted al momento
        de entregárselos. En caso de reemplazo o reparación, la Plataforma de Lealtad
        VIVOTEK no asume la titularidad del producto a reemplazar o reparar hasta
        haberlo recibido en la dirección previamente acordada.<br><br>
        FALLAS EN EL SISTEMA<br>
        La Plataforma de Lealtad VIVOTEK no se hace responsable de cualquier daño o
        pérdida causada por fallas en el sistema, en el servidor o en internet, así como
        tampoco nos haremos responsables de cualquier virus que pueda infectar el
        dispositivo con el que el usuario ingrese y haga uso de nuestra plataforma.
        Tampoco podemos garantizar el acceso y uso ininterrumpido de la Plataforma de
        Lealtad VIVOTEK, ya que pueden presentarse dificultades técnicas eventuales o
        fallas en internet que impidan la disponibilidad de nuestros servicios.<br><br>
        LICENCIA<br>
        Sujeto al cumplimiento de los presentes Términos y Condiciones, la Plataforma de
        Lealtad VIVOTEK otorga a sus usuarios o consumidores una autorización limitada,
        no exclusiva, revocable y no transferible para acceder y hacer uso de su
        plataforma en los dispositivos personales que desee a través de una cuenta de
        usuario única y no transferible.<br><br>
        VIOLACIÓN DEL SISTEMA<br>
        Queda estrictamente prohibida toda acción que atente contra las actividades y
        operaciones de la Plataforma de Lealtad VIVOTEK, incluyendo actos de ingeniería
        de reversa, manipulación de software, o cualquier intento por interferir con
        nuestros servicios en lo relacionado con las ofertas, descripciones, cuentas o
        bases de datos de dicha plataforma.<br><br>
        MODIFICACIÓN<br>
        Nos reservamos el derecho de suspender cualquiera de los servicios de la
        Plataforma de Lealtad VIVOTEK, así como de incorporar nuevas funciones y
        realizar cualquier modificación asociada con las funciones y accesos de la
        plataforma, sin la obligación de notificarle a usted sobre dichas acciones.
        La Plataforma de Lealtad VIVOTEK también podrá modificar los presentes
        Términos y Condiciones en cualquier momento, teniendo efectividad inmediata
        desde el momento en que sean publicadas dichas modificaciones. Al aceptar los
        presentes Términos y Condiciones, también estará aceptando apegarse a
        cualquier modificación que en estos se aplique.<br><br>
        COMPRAS<br>
        Para adquirir cualquiera de los productos ofertados en la Tienda dentro de la
        Plataforma de Lealtad VIVOTEK, usted deberá seguir estos sencillos pasos:<br>
        1. Usted deberá canjear sus VIVOCOINS disponibles por el artículo deseado en la
        plataforma al dar clic en el botón “Canjear” del mismo. Inmediatamente, la cantidad
        de VIVOCOINS que le dan valor a dicho artículo será restado de su cuenta.<br>
        2. Luego de unos momentos, llegará a su bandeja un correo electrónico que le
        notificará que su pedido se encuentra En Proceso de validación.<br>
        3. Una vez confirmada la disponibilidad del producto, llegará a su bandeja un
        segundo correo electrónico dando por Aceptado su pedido.<br>
        4. Posteriormente, la Plataforma de Lealtad VIVOTEK le notificará vía correo
        electrónico los datos de entrega de su producto adquirido (fecha, hora y lugar)
        para que pueda pasar a recogerlos a las oficinas más cercanas del distribuidor o
        mayorista.<br>
        5. El estatus de su pedido cambiará a Finalizado una vez que el mayorista o
        distribuidor encargado nos confirme que éste ha sido entregado exitosamente.<br><br>
        CANCELACIÓN<br>
        La Plataforma de Lealtad VIVOTEK se reserva el derecho de limitar o cancelar
        artículos canjeados, así como de rechazar cualquier pedido. La Plataforma de
        Lealtad VIVOTEK siempre notificará vía correo electrónico a los usuarios o
        consumidores en caso de la cancelación de sus pedidos, haciendo la devolución
        total de los VIVOCOINS correspondientes.
        Los VIVOCOINS asignados a cada uno de los artículos de la plataforma son
        susceptibles a cambios, por lo que la Plataforma de Lealtad VIVOTEK se reserva
        el derecho de hacer modificaciones en la cantidad de VIVOCOINS pertenecientes
        a cualquier producto que se oferta en el catálogo.
        GARANTÍA.
        La Plataforma de Lealtad VIVOTEK ofrece un periodo de garantía diferente para
        cada uno de los productos ahí ofertados (como se indica en la hoja de
        especificaciones*); sin embargo, la fecha de inicio de garantía para todos los
        casos será considerada a partir de que el estatus de los pedidos realizados en la
        Plataforma de Lealtad VIVOTEK cambie a “finalizado”, la cual será verificada
        mediante el recibo de envío de VIVOTEK.
        VIVOTEK está obligado a remplazar con un producto nuevo cualquier artículo
        adquirido en la Plataforma de Lealtad VIVOTEK que sea reportado, en un plazo no
        mayor a 4 meses después de su compra, por presentar un mal funcionamiento;
        siempre y cuando, luego de haberse realizado un diagnóstico técnico, los
        ingenieros de solución de problemas determinen que los defectos del producto no
        son causa de una intervención inadecuada o configuración incorrecta por parte del
        usuario o consumidor. Este agravio está catalogado como Daño a la Llegada
        (DOA, por sus siglas en inglés).
        En caso de que el modelo del producto a remplazar no se encuentre disponible en
        el stock del mayorista o distribuidor, la Plataforma de Lealtad VIVOTEK se pondrá
        en contacto con usted para consultarle si desea esperar a que el producto se
        encuentre disponible o, en su defecto, si desea recibir un producto similar. En caso
        de preferir la segunda opción, nosotros nos encargaremos de seleccionar el
        producto nuevo con el que se remplazará el producto viejo.
        Los productos adquiridos en la Plataforma de Lealtad VIVOTEK que sean
        entregados de manera incompleta (sin los accesorios prometidos en su
        descripción), no serán remplazados por productos nuevos, sino que dichos
        accesorios serán enviados a la brevedad luego de los usuarios o consumidores
        reporten la falta.
        VIVOTEK también puede realizar la reparación de fallos generales a aquellos
        productos originales adquiridos en la Plataforma de Lealtad VIVOTEK reportados
        por no funcionar normalmente, siempre y cuando los ingenieros de solución de
        problemas determinen que los defectos del producto no son causa de una
        intervención inadecuada o configuración incorrecta por parte del usuario o
        consumidor. Esta situación está catalogada como Autorización de Devolución de
        Mercancía (RMA, por sus siglas en inglés).
        Usted no podrá hacer efectiva su garantía sobre ningún producto adquirido en la
        Plataforma de Lealtad VIVOTEK si incurre en cualquiera de los siguientes casos:<br>
        a) reportar el mal funcionamiento del producto una vez concluido el periodo de
        garantía; <br> b) si después de haberse realizado el diagnóstico técnico, los
        ingenieros de solución de problemas determinan que los defectos del producto son
        causados por factores atribuibles al mismo usuario o consumidor.
        <br>
        *La garantía de accesorios consumibles es de 4 meses; la garantía de lentes
        adicionales o accesorias es de 1 año; si un producto incluye lentes o accesorios, la
        garantía de los accesorios será la misma que la del producto principal.
        La Plataforma de Lealtad VIVOTEK actúa como medio para la comercialización de
        productos de diversos mayoristas o distribuidores que manejan sus propias
        garantías específicas, por lo cual la Plataforma de Lealtad VIVOTEK no está
        obligada en ninguna circunstancia a responder por las garantías específicas de
        dichos mayoristas o distribuidores. Para conocer tales garantías específicas, le
        recomendamos contactar directamente con el mayorista o distribuidor de su
        interés.
        La Plataforma de Lealtad VIVOTEK no será responsable del retraso o
        incumplimiento de pedidos cuando las causas queden fuera de su control
        razonable, incluyendo, de manera no limitativa, casos fortuitos, disturbios,
        embargos, incendios, inundaciones, accidentes, huelgas, escasez de combustible
        o energía, etc.<br><br>
        GARANTÍA EXTENDIDA<br>
        La Plataforma de Lealtad VIVOTEK ofrece un servicio de Garantía Extendida que
        incrementa de manera importante su periodo de validez, servicio que usted podrá
        adquirir al contactarse con cualquier representante de ventas de VIVOTEK.
        La Garantía Extendida de la Plataforma de Lealtad VIVOTEK implica los
        siguientes aspectos:<br>
        1. La Garantía Extendida aplica para un máximo de 3 años posteriores a la
        expiración del periodo de la garantía común.<br>
        2. La Garantía Extendida aplica para cámaras, codificadores de video,
        decodificadores de video, grabadores de video y switches PoE (mas no
        aplica para accesorios y kits de instalación).<br>
        3. La Garantía Extendida podrá ser adquirida únicamente al momento de
        realizar la compra del producto en la Plataforma de Lealtad VIVOTEK o, en
        su defecto, 6 meses después de haberla realizado.<br>
        4. Los productos que hayan sido adquiridos en la Plataforma de Lealtad
        VIVOTEK bajo el concepto de EOS* no podrán contar con nuestro servicio
        de Extensión de Garantía.<br>
        5. La Plataforma de Lealtad VIVOTEK se reserva el derecho de aprobar o
        rechazar cualquier Extensión de Garantía.<br>
        Si quiere obtener más información sobre el concepto EOS, póngase en contacto
        con el departamento de ventas de VIVOTEK.<br><br>
        <b>DOMICILIO Y LEGISLACIÓN APLICABLE</b><br>
        En caso de presentarse alguna disputa entre usted y la Plataforma de Lealtad
        VIVOTEK en relación con nuestros servicios o con lo establecido en los presentes
        Términos y Condiciones, será resuelta en un primer momento a través de la
        jurisdicción administrativa de la Procuraduría Federal del Consumidor (Profeco),
        por lo que únicamente habiéndose agotado el proceso ante la mencionada
        procuraduría, se podrá acudir ante la Comisión de Mediación y Arbitraje de la
        Cámara Nacional de Comercio (Canaco) y de acuerdo con las leyes vigentes en la
        República Mexicana.
        Para el caso de las disputas que se resuelvan a través de la Canaco, se estará al
        contenido de los siguientes párrafos:
        Todo litigio, controversia o reclamación resultante de este contrato o relativo a este
        contrato, su incumplimiento, resolución o nulidad, se resolverá mediante arbitraje
        de conformidad con el Reglamento de Arbitraje de la Cámara Nacional de
        Comercio de la Ciudad de México o el Reglamento para Arbitrajes de Baja Cuantía
        o Arbitraje Acelerado de la Cámara Nacional de Comercio de la Ciudad de México,
        según sea el caso por razón de cuantía.
        Asimismo, se acuerda que el proceso será resuelto por un árbitro único, en la
        Ciudad de México en los Estados Unidos Mexicanos, se llevará a cabo en idioma
        español, siendo aplicable la legislación vigente en la República Mexicana.
        En este contexto, Usted renuncia expresamente al fuero que pudiese
        corresponderle por razón de su domicilio presente o futuro.<br><br>
        <b>TÉRMINO O SUSPENSIÓN DE SERVICIOS</b><br>
        La Plataforma de Lealtad VIVOTEK se reserva el derecho de terminar o
        suspender, por cualquier razón valorada a nuestro criterio en relación con el
        incumplimiento de los presentes Términos y Condiciones, su uso de nuestros
        servicios o su cuenta.<br><br>
        <b>ACEPTACIÓN TOTAL DE LOS TÉRMINOS Y CONDICIONES</b><br>
        Usted manifiesta haber leído, entendido y aceptado en su totalidad los presentes
        Términos y Condiciones de uso de la Plataforma de Lealtad VIVOTEK, por lo que
        se compromete al cumplimiento total de los deberes, obligaciones, acciones y
        omisiones expresadas en este documento.
      </p><br>
      <div class="row">
          <vs-button color="danger" type="relief" @click="hideModal">Cancelar</vs-button>&nbsp;&nbsp; 
          <vs-button type="relief" @click="Aceptar()">Aceptar</vs-button>
      </div>
    </vs-popup>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:40'"
      name="password"
      label-placeholder="Password"
      placeholder="Contraseña"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <vs-input
      type="password"
      v-validate="'min:6|max:40|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirmar Contraseña"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
    <vs-checkbox @change="openAlert()"  v-model="isTermsConditionAccepted" class="mt-6">Acepto los Términos y Condiciones de Uso</vs-checkbox>
    <vs-button  type="border" to="/pages/login" class="mt-6">Regresar a Login</vs-button>
    <vs-button class="float-right mt-6" @click="registerUser" :disabled="!validateForm">Registrarme</vs-button>
  </div>


</template>


<script>

import Vue from 'vue'

export default {
  data () {
    return {
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: false,
      popupActivo: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted == true
    }
  },
  methods: {
    showModal() {
      this.popupActivo=true;
      this.isTermsConditionAccepted=false;
    },
    hideModal() {
      this.popupActivo=false;
      this.isTermsConditionAccepted=false;
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },
    registerUser () {
      if(this.isTermsConditionAccepted==true){
        if (!this.validateForm || !this.checkLogin()) return
        const payload = {
          userDetails: {
            //displayName: this.email,
            email: this.email,
            password: this.password,
            confirmPassword: this.confirm_password
          },
          notify: this.$vs.notify
        }
        this.$store.dispatch('auth/registerUser', payload)
      }else{
      }
    },
    Aceptar(){
      this.isTermsConditionAccepted=true;
      this.popupActivo=false;
    },
    openAlert(){
      this.showModal();
    },
  },
  components: {
  },
}
</script>